import { areDatesEqual } from './areDatesEqual';

export function areDatesEqualOrBothUndefined(dateA: Date | undefined, dateB: Date | undefined): boolean {
  if (!dateA && !dateB) return true;
  if (!dateA || !dateB) return false;

  return areDatesEqual(dateA, dateB);
}
